/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_violin_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Violin Plot Maker (Free, Online) — Toolverse`)
};

const es_violin_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Gráficos de Violín (Gratis, Online) — Toolverse`)
};

const de_violin_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Violin-Plot-Generator (Kostenlos, Online) — Toolverse`)
};

const nl_violin_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vioolplot Maker (Gratis, Online) — Toolverse`)
};

const fr_violin_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de graphique en violon (gratuit, en ligne) — Toolverse`)
};

const it_violin_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di Grafici a Violino (Gratis, Online) — Toolverse`)
};

const pt_br2_violin_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Gráfico de Violino (Grátis, Online) — Toolverse`)
};

const pt_violin_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Gráficos de Violino (Grátis, Online) — Toolverse`)
};

const ja_violin_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バイオリンプロット作成ツール(無料・オンライン) — Toolverse`)
};

const zh_violin_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小提琴图生成器（免费、在线）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const violin_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.violin_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("violin_meta_title", locale)
	if (locale === "en") return en_violin_meta_title(inputs)
	if (locale === "es") return es_violin_meta_title(inputs)
	if (locale === "de") return de_violin_meta_title(inputs)
	if (locale === "nl") return nl_violin_meta_title(inputs)
	if (locale === "fr") return fr_violin_meta_title(inputs)
	if (locale === "it") return it_violin_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_violin_meta_title(inputs)
	if (locale === "pt") return pt_violin_meta_title(inputs)
	if (locale === "ja") return ja_violin_meta_title(inputs)
	return zh_violin_meta_title(inputs)
};